import React from "react"
import { BblImageTextColumnsBlockPreview } from "./queries"
import { makeStyles } from "@material-ui/styles"
import { buildBlocks } from "../../../services/builder"
import styles from "./styles"
import Wrapper from "../../Reusable/Wrapper"

const useStyles = makeStyles(theme => styles(theme))

export const BblImageTextColumnsBlock = ({
  attributes,
  innerBlocks,
  parentAttributes,
  pageContext,
}) => {
  const blocks = buildBlocks(innerBlocks, parentAttributes, pageContext)
  const classes = useStyles()

  const { className, photoLeft, textTop } = attributes

  return (
    <div
      className={`image-text-columns ${className} ${classes.imageTextColumns} `}
      data-photo-left={photoLeft}
      data-text-top={textTop}
    >
      <Wrapper>
        {blocks.map(block => {
          return block
        })}
      </Wrapper>
    </div>
  )
}

export { BblImageTextColumnsBlockPreview }
